import { render, staticRenderFns } from "./transfer-check.vue?vue&type=template&id=f46d401a&"
import script from "./transfer-check.vue?vue&type=script&lang=js&"
export * from "./transfer-check.vue?vue&type=script&lang=js&"
import style0 from "./transfer-check.vue?vue&type=style&index=0&id=f46d401a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports